




























































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Toolbox from "@/components/Toolbox.vue";
import Paginator from "@/components/Paginator.vue";
import { Script } from "../interfaces/script";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import { SocketService } from "../services/socketService";
import StudioManagerEditForm from "@/components/StudioManagerEditForm.vue";
import { ReportService } from "../services/reportService";
import ReportCreateDialog from "@/components/ReportCreateDialog.vue";
import { StudioAttributes } from "../interfaces/studioAttributes";
import BackgroundSettings from "@/interfaces/studioBackground";
import QuickConnectDialog from "@/components/QuickConnectDialog.vue";
import { StudioService } from "@/services/roomService";
import { Page } from "@/interfaces/page";
import { StudioState } from "@/interfaces/studioState";

@Component({
    components: {
        Toolbox,
        Paginator,
        StudioManagerEditForm,
        ReportCreateDialog,
        QuickConnectDialog,
    },
})
export default class StudioBar extends Vue {
    @Prop() public script!: Script | null;
    @Prop() public pageIndex!: number;
    @Prop() public studioId!: string;

    @Prop() public configurations!: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    >[];

    @Emit() public toolboxClick(event: { type: string; static: boolean }) {
        return event;
    }

    public navigationVisible: boolean = true;
    public toolboxVisible: boolean = false;
    public pagesVisible: boolean = false;
    public editModeActive: boolean = false;
    public token: string = "";
    public reportCreateDialogActive: boolean = false;

    public async mounted() {
        this.token = await this.$auth?.getTokenSilently();
    }

    public get studio() {
        return this.$store.state?.studio;
    }

    public endEditMode() {
        this.editModeActive = false;
    }

    public async createReport(name: string) {
        this.reportCreateDialogActive = false;
        let payload:
            | Page[]
            | Omit<
                  StudioState,
                  | "presenters"
                  | "users"
                  | "quick_connect_codes"
                  | "healthySession"
              >[] = [];
        const recentStudio = await StudioService.getStudio(
            this.studio.studioId,
            this.token
        );
        const {
            studioName,
            studioId,
            layout,
            widgetConfig,
            attributes,
            backgroundSettings,
            authorizationActive,
        } = recentStudio.studio;
        payload = [
            {
                studioName,
                studioId,
                layout,
                widgetConfig,
                attributes,
                backgroundSettings,
                authorizationActive,
            },
        ];

        if (this.script) {
            this.script.pages[this.pageIndex].widgetConfig =
                recentStudio.studio.widgetConfig;
            payload = this.script.pages;
        }

        ReportService.createReport(
            name,
            this.$store.state.user.id,
            this.studioId,
            payload,
            this.token
        );
    }

    @Emit() public prev() {
        return;
    }

    @Emit() public next() {
        return;
    }

    @Emit() public load() {
        return;
    }

    @Emit() public showparticipants() {
        SocketService.participantInfoRequest(this.$store.state.studio.studioId);
        return;
    }
    @Emit() public reuse(event: { widgetId: string }) {
        return event;
    }

    @Emit() public paginatorClick(event: { index: number }) {
        return event;
    }
    @Emit() public navigationToggle(): boolean {
        this.navigationVisible = !this.navigationVisible;
        return this.navigationVisible;
    }

    public changeStudioAttributes(newAttr: {
        studioId: string;
        attributes: StudioAttributes;
    }) {
        this.$store.commit("localAttributesUpdated", {
            attributes: newAttr.attributes,
        });
        SocketService.updateAttributes(newAttr.studioId, newAttr.attributes);
    }

    public changeBackground(payload: {
        background: BackgroundSettings | null;
        studioId: string;
    }) {
        SocketService.updateBackground(this.studioId, payload.background);
    }

    public get participants(): number | null {
        return this.$store.state.studio?.attributes.participants;
    }
    public async participantlist() {
        // alert("I was clck");
        await SocketService.participantInfoRequest(
            this.$store.state.studio.studioId
        );
    }
}
